/**
 * exposed to outside as props
 */
export var IconAlignmentTokens;
(function (IconAlignmentTokens) {
    IconAlignmentTokens["left"] = "left";
    IconAlignmentTokens["center"] = "center";
    IconAlignmentTokens["right"] = "right";
})(IconAlignmentTokens || (IconAlignmentTokens = {}));
export var IconLabelAlignment;
(function (IconLabelAlignment) {
    IconLabelAlignment["ROW"] = "ROW";
    IconLabelAlignment["COLUMN"] = "COLUMN";
})(IconLabelAlignment || (IconLabelAlignment = {}));
export var IconTokens;
(function (IconTokens) {
    IconTokens["Kfin"] = "kfin";
    IconTokens["Cdsl"] = "cdsl";
    IconTokens["Cams"] = "Cams";
    IconTokens["PoweredBy"] = "powered-by";
    IconTokens["Chat"] = "chat";
    IconTokens["Edit"] = "edit";
    IconTokens["Search"] = "search";
    IconTokens["Upload"] = "upload";
    IconTokens["Attachment"] = "attachment";
    IconTokens["Back"] = "back";
    IconTokens["PlusCircle"] = "plus-circle";
    IconTokens["Cross"] = "cross";
    IconTokens["Play"] = "play";
    IconTokens["CheckTwo"] = "check-two";
    IconTokens["ThreeDots"] = "three-dots";
    IconTokens["LocationPin"] = "location-pin";
    IconTokens["RightArrow"] = "right-arrow";
    IconTokens["DownArrow"] = "down-arrow";
    IconTokens["Quotes"] = "quotes";
    IconTokens["Plus"] = "plus";
    IconTokens["Shuffle"] = "shuffle";
    IconTokens["MinusCircle"] = "minus-circle";
    IconTokens["Calendar"] = "calendar";
    IconTokens["Cake"] = "cake";
    IconTokens["BriefCase"] = "briefcase";
    IconTokens["Book"] = "book";
    IconTokens["DoubleMessage"] = "double-message";
    IconTokens["Info"] = "info";
    IconTokens["InfoFilled"] = "info-filled";
    IconTokens["InfoStatic"] = "info-static";
    IconTokens["Lighting"] = "lighting";
    IconTokens["Notification"] = "notification";
    IconTokens["Download"] = "download";
    IconTokens["Mic"] = "mic";
    IconTokens["PDF"] = "pdf";
    IconTokens["Gallery"] = "gallery";
    IconTokens["Video"] = "video";
    IconTokens["SendSolid"] = "send-solid";
    IconTokens["RightAngle"] = "right-angle";
    IconTokens["Fire"] = "fire";
    IconTokens["Newspaper"] = "newspaper";
    IconTokens["Share"] = "share";
    IconTokens["Google"] = "google";
    IconTokens["Messages"] = "messages";
    IconTokens["Star"] = "star";
    IconTokens["Sparkling"] = "sparkling";
    IconTokens["Bookmark"] = "bookmark";
    IconTokens["BookmarkFilled"] = "bookmark-filled";
    IconTokens["Page"] = "page";
    IconTokens["Sticker"] = "sticker";
    IconTokens["TwoUsers"] = "two-users";
    IconTokens["Check"] = "check";
    IconTokens["Dot"] = "dot";
    IconTokens["BulbFilled"] = "bulb-filled";
    IconTokens["BulbOutline"] = "bulb-outline";
    IconTokens["Delete"] = "delete";
    IconTokens["AddUser"] = "add-user";
    IconTokens["CheckCircle"] = "check-circle";
    IconTokens["Clock"] = "clock";
    IconTokens["UserClock"] = "user-clock";
    IconTokens["Like"] = "like";
    IconTokens["LikeFilled"] = "like-filled";
    IconTokens["Comment"] = "comment";
    IconTokens["StarOutline"] = "star-outline";
    IconTokens["Link"] = "link";
    IconTokens["Diamond"] = "diamond";
    IconTokens["Gift"] = "gift";
    IconTokens["Circle"] = "Circle";
    IconTokens["CheckFilled"] = "check-filled";
    IconTokens["InvertedComma"] = "inverted-comma";
    IconTokens["CheckedSquare"] = "checked-square";
    IconTokens["NotCheckedSquare"] = "not-checked-square";
    IconTokens["Done"] = "done";
    IconTokens["Error"] = "error";
    IconTokens["Email"] = "email";
    IconTokens["Secure"] = "secure";
    IconTokens["EmptyCircle"] = "empty-circle";
    IconTokens["RadioCircleFilled"] = "radio-circle-filled";
    IconTokens["SystemError"] = "system-error";
    IconTokens["Phone"] = "Phone";
    IconTokens["CreditCard"] = "CreditCard";
    IconTokens["Default"] = "Default";
    IconTokens["InProgress"] = "InProgress";
    IconTokens["Success"] = "Success";
    IconTokens["Alert"] = "Alert";
    IconTokens["Failed"] = "Failed";
    IconTokens["Right"] = "Right";
    IconTokens["ChevronDown"] = "ChevronDown";
    IconTokens["SystemWarning"] = "SystemWarning";
    IconTokens["RadioCircleNotFilled"] = "radio-circle-not-filled";
    IconTokens["Chart"] = "Chart";
    IconTokens["RuppeFile"] = "RuppeFile";
    IconTokens["Square"] = "Square";
    IconTokens["GiftOutline"] = "GiftOutline";
    IconTokens["InfoCropped"] = "InfoCropped";
    IconTokens["Volt"] = "Volt";
    IconTokens["ChervonDownRight"] = "ChervonDownRight";
    IconTokens["Camera"] = "Camera";
    IconTokens["CameraOff"] = "CameraOff";
    IconTokens["Coin"] = "Coin";
    IconTokens["SafeGuard"] = "SafeGuard";
    IconTokens["Account"] = "Account";
    IconTokens["Rectangle"] = "Rectangle";
    IconTokens["Cancel"] = "Cancel";
    IconTokens["Person"] = "Person";
    IconTokens["Location"] = "Location";
    IconTokens["Add"] = "Add";
    IconTokens["Lock"] = "Lock";
    IconTokens["Copy"] = "Copy";
    IconTokens["InfoMessage"] = "InfoMessage";
    IconTokens["Group46"] = "Group46";
    IconTokens["GoogleSVG"] = "GoogleSVG";
    IconTokens["OTPError"] = "OTPError";
    IconTokens["DocFile"] = "DocFile";
    IconTokens["Notebook"] = "Notebook";
    IconTokens["ContractFile"] = "ContractFile";
    IconTokens["FreeBook"] = "FreeBook";
    IconTokens["User"] = "User";
    IconTokens["Whatsapp"] = "Whatsapp";
    IconTokens["Locked"] = "Locked";
    IconTokens["HeadPhone"] = "HeadPhone";
    IconTokens["Question"] = "Question";
    IconTokens["Logout"] = "Logout";
    IconTokens["ManageLimit"] = "ManageLimit";
    IconTokens["Support"] = "Support";
    IconTokens["File"] = "File";
    IconTokens["VoltFull"] = "VoltFull";
    IconTokens["Group74508"] = "Group74508";
    IconTokens["NOTSELCTEDCHART"] = "NOTSELCTEDCHART";
    IconTokens["TransactionNotSelected"] = "TransactionNotSelected";
    IconTokens["Sound"] = "Sound";
    IconTokens["ChevronLeft"] = "ChevronLeft";
    IconTokens["GreenRupee"] = "GreenRupee";
    IconTokens["GreenClipboard"] = "GreenClipboard";
    IconTokens["Telegram"] = "Telegram";
    IconTokens["ThreeBar"] = "ThreeBar";
    IconTokens["Bajaj"] = "Bajaj";
    IconTokens["Nsdl"] = "Nsdl";
    IconTokens["ThumpsUp"] = "ThumpsUp";
    IconTokens["ShakeHands"] = "ShakeHands";
    IconTokens["BellNotified"] = "BellNotified";
    IconTokens["List"] = "List";
    IconTokens["SvgChart"] = "SvgChart";
    IconTokens["Redirecting"] = "Redirecting";
    IconTokens["FAQ"] = "FAQ";
    IconTokens["ShieldRuppee"] = "ShieldRuppee";
    IconTokens["EditBlue"] = "EditBlue";
    IconTokens["ManageLimitSelected"] = "ManageLimitSelected";
    IconTokens["SMS"] = "SMS";
    IconTokens["OTPEmail"] = "OTPEmail";
    IconTokens["UpsideArrow"] = "UpsideArrow";
    IconTokens["GreenXls"] = "GreenXls";
    IconTokens["ChevronUp"] = "ChevronUp";
    IconTokens["SystemSuccess"] = "SystemSuccess";
    IconTokens["CoveredRightArrow"] = "CoveredRightArrow";
    IconTokens["Leads"] = "Leads";
    IconTokens["Grid_View"] = "Grid_View";
    IconTokens["NoNetwork"] = "NoNetwork";
    IconTokens["SuccessIcon"] = "SuccessIcon";
    IconTokens["Pending"] = "Pending";
    IconTokens["PendingRepay"] = "PendingRepay";
    IconTokens["FailedNew"] = "FailedNew";
    IconTokens["AutoPayArrow"] = "AutoPayArrow";
    IconTokens["Warning"] = "Warning";
    IconTokens["VoltPartner"] = "VoltPartner";
    IconTokens["GoldenThunder"] = "GoldenThunder";
    IconTokens["Brochure2"] = "Brochure2";
    IconTokens["ADD_FRIEND"] = "ADD_FRIEND";
    IconTokens["Lead2"] = "Lead2";
    IconTokens["Gift2"] = "Gift2";
    IconTokens["ShareLink2"] = "ShareLink2";
    IconTokens["Earning"] = "Earning";
    IconTokens["Collateral"] = "Collateral";
    IconTokens["DemoVideo"] = "DemoVideo";
    IconTokens["ProfileDetails"] = "ProfileDetails";
    IconTokens["BillingDetails"] = "BillingDetails";
    IconTokens["Faq2"] = "Faq2";
    IconTokens["AboutUs2"] = "AboutUs2";
    IconTokens["AccountDetails"] = "AccountDetails";
    IconTokens["Lead3"] = "Lead3";
    IconTokens["Customer3"] = "Customer3";
    IconTokens["Earning3"] = "Earning3";
    IconTokens["Partner3"] = "Partner3";
    IconTokens["Bijli"] = "Bijli";
    IconTokens["Megaphone"] = "Megaphone";
    IconTokens["Share4"] = "Share4";
    IconTokens["TenToFiftyThousand"] = "TenToFiftyThousand";
    IconTokens["FiftyToTwoLakh"] = "FiftyToTwoLakh";
    IconTokens["TwoToTenLakh"] = "TwoToTenLakh";
    IconTokens["MoreThanTenLakh"] = "MoreThanTenLakh";
    IconTokens["NoMutualFund"] = "NoMutualFund";
    IconTokens["YesMutualFundDefault"] = "YesMutualFundDefault";
    IconTokens["YesMutualFundSelected"] = "YesMutualFundSelected";
    IconTokens["NoMutualFundDefault"] = "NoMutualFundDefault";
    IconTokens["NoMutualFundSelected"] = "NoMutualFundSelected";
    IconTokens["SliderIcon"] = "SliderIcon";
    IconTokens["LinkedPartners"] = "LinkedPartners";
    IconTokens["VoltPlatform"] = "VoltPlatform";
    IconTokens["PasswordHide"] = "PasswordHide";
    IconTokens["PasswordShow"] = "PasswordShow";
    IconTokens["RightBlueArrow"] = "RightBlueArrow";
    IconTokens["CrossIcon"] = "CrossIcon";
    IconTokens["ErrorIcon"] = "ErrorIcon";
    IconTokens["SuccessIcon1"] = "SuccessIcon1";
    IconTokens["VerifiedIcon1"] = "VerifiedIcon1";
    IconTokens["Check_Limit_1"] = "Check_Limit_1";
    IconTokens["Check_Limit_Grey"] = "Check_Limit_Grey";
    IconTokens["Meter_1"] = "Meter_1";
    IconTokens["Percentage"] = "Percentage";
    IconTokens["InfoImage"] = "InfoImage";
    IconTokens["SecureIcon"] = "SecureIcon";
    IconTokens["InfoIcon"] = "InfoIcon";
    IconTokens["Debit"] = "Debit";
    IconTokens["Credit"] = "Credit";
    IconTokens["CreditTdl"] = "CreditTdl";
    IconTokens["DebitTdl"] = "DebitTdl";
    IconTokens["TransactionSuccess"] = "TransactionSuccess";
    IconTokens["TransactionInProgress"] = "TransactionInProgress";
    IconTokens["DigioIcon"] = "DigioIcon";
    IconTokens["ChevronUpV2"] = "ChevronUpV2";
    IconTokens["ChevronDownV2"] = "ChevronDownV2";
    IconTokens["LENDER_BAJAJ"] = "LENDER_BAJAJ";
    IconTokens["LENDER_MIRAE"] = "LENDER_MIRAE";
    IconTokens["LENDER_TATA"] = "LENDER_TATA";
    IconTokens["LENDER_NUVAMA"] = "LENDER_NUVAMA";
    IconTokens["greenPercentage1"] = "greenPercentage1";
    IconTokens["greenClock1"] = "greenClock1";
    IconTokens["greenRupee1"] = "greenRupee1";
    IconTokens["BackArrowIcon"] = "BackArrowIcon";
    IconTokens["Pan1"] = "Pan1";
    IconTokens["Verify_Aadhar1"] = "Verify_Aadhar1";
    IconTokens["Verify_Bank1"] = "Verify_Bank1";
    IconTokens["flash"] = "flash";
    IconTokens["foreclosure"] = "foreclosure";
    IconTokens["System_delete"] = "System_delete";
    IconTokens["UpiIcon"] = "UpiIcon";
    IconTokens["NetBanking"] = "NetBanking";
    IconTokens["UpBlackArrow"] = "UpBlackArrow";
    IconTokens["DownBlackArrow"] = "DownBlackArrow";
    IconTokens["UpiInProgress"] = "UpiInProgress";
    IconTokens["RightBlackIcon"] = "RightBlackIcon";
    IconTokens["LeftBlackArrowIcon"] = "LeftBlackArrowIcon";
    IconTokens["SelectIcon"] = "SelectIcon";
    IconTokens["ShareIcon"] = "ShareIcon";
    IconTokens["AddPhoto"] = "AddPhoto";
    IconTokens["MailIcon"] = "MailIcon";
    IconTokens["CheckSms"] = "CheckSms";
    IconTokens["Filter"] = "Filter";
    IconTokens["UnSelectedRadioButton"] = "UnSelectedRadioButton";
    IconTokens["InProgressGrey"] = "InProgressGrey";
    IconTokens["APIFailureIcon"] = "APIFailureIcon";
    IconTokens["ContactHeadphones"] = "ContactHeadphones";
    IconTokens["VoltLogoNew"] = "VoltLogoNew";
    IconTokens["MessageOtp"] = "MessageOtp";
    IconTokens["Account_profile"] = "Account_profile";
    IconTokens["AboutUs"] = "AboutUs";
    IconTokens["Logout_Profile"] = "Logout_Profile";
    IconTokens["MY_LOAN_PROFILE_ICON"] = "MY_LOAN_PROFILE_ICON";
    IconTokens["AshokChakra"] = "AshokChakra";
    IconTokens["IncomeTax"] = "IncomeTax";
    IconTokens["ClockCheckLimit"] = "ClockCheckLimit";
    IconTokens["Illustration"] = "Illustration";
    IconTokens["THUNDER_GREEN"] = "THUNDER_GREEN";
    IconTokens["CURRENCY_GREEN"] = "CURRENCY_GREEN";
    IconTokens["TRENDING_GREEN"] = "TRENDING_GREEN";
    IconTokens["CHECKED_ROUNDED_DLS"] = "CHECKED_ROUNDED_DLS";
    IconTokens["UNCHECK_ROUNDED_DLS"] = "UNCHECK_ROUNDED_DLS";
    IconTokens["CHECK_SQUARE_DLS"] = "CHECK_SQUARE_DLS";
    IconTokens["UNCHECK_SQUARE_DLS"] = "UNCHECK_SQUARE_DLS";
    //DLS_SYSTEM_STATUS_ICONS
    IconTokens["SYSTEM_STATUS_ERROR_DLS"] = "SYSTEM_STATUS_ERROR_DLS";
    IconTokens["SYSTEM_STATUS_WARNING_DLS"] = "SYSTEM_STATUS_WARNING_DLS";
    IconTokens["SYSTEM_STATUS_SUCCESS_DLS"] = "SYSTEM_STATUS_SUCCESS_DLS";
    IconTokens["SYSTEM_STATUS_INFO_DLS"] = "SYSTEM_STATUS_INFO_DLS";
    IconTokens["SYSTEM_STATUS_INFO_REDBG_DLS"] = "SYSTEM_STATUS_INFO_REDBG_DLS";
    //DLS_SYSTEM_ICONS
    IconTokens["SYSTEM_SUCCESS_DLS"] = "SYSTEM_SUCCESS_DLS";
    IconTokens["SYSTEM_CHEVRON_DOWN_DLS"] = "SYSTEM_CHEVRON_DOWN_DLS";
    IconTokens["SYSTEM_CHEVRON_UP_DLS"] = "SYSTEM_CHEVRON_UP_DLS";
    IconTokens["SYSTEM_ERROR_DLS"] = "SYSTEM_ERROR_DLS";
    IconTokens["SYSTEM_MAIL_DLS"] = "SYSTEM_MAIL_DLS";
    IconTokens["SYSTEM_CALL_DLS"] = "SYSTEM_CALL_DLS";
    IconTokens["SYSTEM_CLOSE_W_CIRCLE_DLS"] = "SYSTEM_CLOSE_W_CIRCLE_DLS";
    IconTokens["SYSTEM_CANCEL_DLS"] = "SYSTEM_CANCEL_DLS";
    IconTokens["SYSTEM_EDIT_DLS"] = "SYSTEM_EDIT_DLS";
    IconTokens["SYSTEM_PAN_CARD_DLS"] = "SYSTEM_PAN_CARD_DLS";
    IconTokens["SYSTEM_BANK_DLS"] = "SYSTEM_BANK_DLS";
    IconTokens["SYSTEM_SEARCH_DLS"] = "SYSTEM_SEARCH_DLS";
    IconTokens["SYSTEM_ADD_DLS"] = "SYSTEM_ADD_DLS";
    IconTokens["SYSTEM_UNLOCK_DLS"] = "SYSTEM_UNLOCK_DLS";
    IconTokens["SYSTEM_INFO_DLS"] = "SYSTEM_INFO_DLS";
    IconTokens["SYSTEM_FILTER_DLS"] = "SYSTEM_FILTER_DLS";
    IconTokens["SYSTEM_BACK_DLS"] = "SYSTEM_BACK_DLS";
    IconTokens["SYSTEM_PERSON_DLS"] = "SYSTEM_PERSON_DLS";
    IconTokens["SYSTEM_LOCATION_DLS"] = "SYSTEM_LOCATION_DLS";
    IconTokens["SYSTEM_CALENDAR_DLS"] = "SYSTEM_CALENDAR_DLS";
    IconTokens["SYSTEM_DONE_DLS"] = "SYSTEM_DONE_DLS";
    IconTokens["SYSTEM_SHARE_DLS"] = "SYSTEM_SHARE_DLS";
    IconTokens["SYSTEM_NOTIFICATIONS_DLS"] = "SYSTEM_NOTIFICATIONS_DLS";
    IconTokens["SYSTEM_NOTIFICATIONS_ACTIVE_DLS"] = "SYSTEM_NOTIFICATIONS_ACTIVE_DLS";
    IconTokens["SYSTEM_EARLY_NUDGE_DLS"] = "SYSTEM_EARLY_NUDGE_DLS";
    IconTokens["SYSTEM_LATER_NUDGE_DLS"] = "SYSTEM_LATER_NUDGE_DLS";
    IconTokens["SYSTEM_COPY_DLS"] = "SYSTEM_COPY_DLS";
    IconTokens["SYSTEM_SKIP_DLS"] = "SYSTEM_SKIP_DLS";
    IconTokens["SYSTEM_CREDIT_DLS"] = "SYSTEM_CREDIT_DLS";
    IconTokens["SYSTEM_DEBIT_DLS"] = "SYSTEM_DEBIT_DLS";
    IconTokens["SYSTEM_FAQ_DLS"] = "SYSTEM_FAQ_DLS";
    IconTokens["SYSTEM_SUPPORT_DLS"] = "SYSTEM_SUPPORT_DLS";
    IconTokens["SYSTEM_TERMS_DLS"] = "SYSTEM_TERMS_DLS";
    IconTokens["SYSTEM_POLICY_DLS"] = "SYSTEM_POLICY_DLS";
    IconTokens["SYSTEM_LOGOUT_DLS"] = "SYSTEM_LOGOUT_DLS";
    IconTokens["SYSTEM_MESSAGE_DLS"] = "SYSTEM_MESSAGE_DLS";
    IconTokens["SYSTEM_FAQ_V2_DLS"] = "SYSTEM_FAQ_V2_DLS";
    IconTokens["SYSTEM_RUPEE_DLS"] = "SYSTEM_RUPEE_DLS";
    IconTokens["SYSTEM_LINK_DLS"] = "SYSTEM_LINK_DLS";
    IconTokens["SYSTEM_INVESTOR_DLS"] = "SYSTEM_INVESTOR_DLS";
    IconTokens["SYSTEM_PARTNER_DLS"] = "SYSTEM_PARTNER_DLS";
    IconTokens["SYSTEM_WHATSAPP_DLS"] = "SYSTEM_WHATSAPP_DLS";
    IconTokens["SYSTEM_TELEGRAM_DLS"] = "SYSTEM_TELEGRAM_DLS";
    IconTokens["SYSTEM_MENU_DLS"] = "SYSTEM_MENU_DLS";
    IconTokens["SYSTEM_SORT_DLS"] = "SYSTEM_SORT_DLS";
    IconTokens["SYSTEM_EYE_DLS"] = "SYSTEM_EYE_DLS";
    IconTokens["SYSTEM_EYE_HIDE_DLS"] = "SYSTEM_EYE_HIDE_DLS";
    IconTokens["SYSTEM_DELETE_DLS"] = "SYSTEM_DELETE_DLS";
    IconTokens["SYSTEM_CHEVRON_RIGHT_DLS"] = "SYSTEM_CHEVRON_RIGHT_DLS";
    IconTokens["SYSTEM_CHEVRON_LEFT_DLS"] = "SYSTEM_CHEVRON_LEFT_DLS";
    IconTokens["SYSTEM_AADHAR_DLS"] = "SYSTEM_AADHAR_DLS";
    IconTokens["SYSTEM_PAN_V2_DLS"] = "SYSTEM_PAN_V2_DLS";
    IconTokens["SYSTEM_LOAN_FORECLOSURE_DLS"] = "SYSTEM_LOAN_FORECLOSURE_DLS";
    IconTokens["SYSTEM_LOAN_DLS"] = "SYSTEM_LOAN_DLS";
    IconTokens["SYSTEM_DOWNLOAD_DOC_DLS"] = "SYSTEM_DOWNLOAD_DOC_DLS";
    IconTokens["SYSTEM_REDIRECT_DLS"] = "SYSTEM_REDIRECT_DLS";
    //DLS_SYSTEM_ILLUSTRATION_ICONS
    IconTokens["SYSTEM_ILLUSTRATION_DONE_DLS"] = "SYSTEM_ILLUSTRATION_DONE_DLS";
    IconTokens["SYSTEM_ILLUSTRATION_ERROR_DLS"] = "SYSTEM_ILLUSTRATION_ERROR_DLS";
    IconTokens["SYSTEM_ILLUSTRATION_CLEAR_DLS"] = "SYSTEM_ILLUSTRATION_CLEAR_DLS";
    IconTokens["SYSTEM_ILLUSTRATION_PROTECTION_DLS"] = "SYSTEM_ILLUSTRATION_PROTECTION_DLS";
    IconTokens["SYSTEM_ILLUSTRATION_INPROGRESS_DLS"] = "SYSTEM_ILLUSTRATION_INPROGRESS_DLS";
    IconTokens["HEAD_SNAPSHOT"] = "HEAD_SNAPSHOT";
    IconTokens["WORK_ALERT"] = "WORK_ALERT";
    IconTokens["CHEVRON_BLUE_RIGHT"] = "CHEVRON_BLUE_RIGHT";
    IconTokens["LOAN_RENEWAL_1"] = "LOAN_RENEWAL_1";
    IconTokens["CALENDAR_ARROW"] = "CALENDAR_ARROW";
    IconTokens["CAPITAL_GAIN_STATEMENT"] = "CAPITAL_GAIN_STATEMENT";
    IconTokens["PLEDGE_MORE"] = "PLEDGE_MORE";
    IconTokens["REMOVE_PLEDGE"] = "REMOVE_PLEDGE";
    IconTokens["HISTORY_BLUE"] = "HISTORY_BLUE";
    IconTokens["BAJAJ_FULL_LOGO_NEW"] = "BAJAJ_FULL_LOGO_NEW";
    IconTokens["DOCUMENT_GREEN"] = "DOCUMENT_GREEN";
    IconTokens["DOWNLOAD_DOCUMENT"] = "DOWNLOAD_DOCUMENT";
    IconTokens["NO_PLEDGES"] = "NO_PLEDGES";
    IconTokens["HOME_BORROWER_LP"] = "HOME_BORROWER_LP";
    IconTokens["TRANSACTION_BORROWER_LP"] = "TRANSACTION_BORROWER_LP";
    IconTokens["MANAGE_LIMIT_BORROWER_LP"] = "MANAGE_LIMIT_BORROWER_LP";
    IconTokens["EMAIL_VERIFY_MAIL_ICON"] = "EMAIL_VERIFY_MAIL_ICON";
    IconTokens["VERIFY_SMS_ICON"] = "VERIFY_SMS_ICON";
    IconTokens["STEPPER_IN_PROGRESS"] = "STEPPER_IN_PROGRESS";
    IconTokens["SHORTFALL_BRIEFCASE"] = "SHORTFALL_BRIEFCASE";
    IconTokens["SHORTFALL_RUPEES"] = "SHORTFALL_RUPEES";
    IconTokens["CONTACT_US"] = "CONTACT_US";
    IconTokens["CONTACT_ICON"] = "CONTACT_ICON";
    IconTokens["TRANSACTION_PLATFORM"] = "TRANSACTION_PLATFORM";
    IconTokens["INTEREST_CALCULATOR"] = "INTEREST_CALCULATOR";
    IconTokens["INTEREST_CALCULATOR_DASHBOARD"] = "INTEREST_CALCULATOR_DASHBOARD";
    IconTokens["PENDING_LIST"] = "PENDING_LIST";
    IconTokens["LOAN_RENEW"] = "LOAN_RENEW";
    IconTokens["WHATSAPP_OUTLINE"] = "WHATSAPP_OUTLINE";
    IconTokens["PENDING_AGREEMENT"] = "PENDING_AGREEMENT";
    IconTokens["INTEREST_RATE"] = "INTEREST_RATE";
    IconTokens["TENURE_DATE"] = "TENURE_DATE";
    IconTokens["WORKSPACE_PREMIUM"] = "WORKSPACE_PREMIUM";
    IconTokens["CELEBRATION"] = "CELEBRATION";
    IconTokens["PAYMENTS"] = "PAYMENTS";
    IconTokens["RECIEPT_LONG"] = "RECIEPT_LONG";
    IconTokens["RUPEE_BG"] = "RUPEE_BG";
    IconTokens["TRANSACTION_FAILED"] = "TRANSACTION_FAILED";
    IconTokens["SOFT_ERROR_ICON"] = "SOFT_ERROR_ICON";
    IconTokens["DSP_LOGO"] = "DSP_LOGO";
    IconTokens["RED_ERROR_ICON"] = "RED_ERROR_ICON";
    IconTokens["CONGRATULATIONS_RIPPLE"] = "CONGRATULATIONS_RIPPLE";
    IconTokens["FETCH_SUCCESS"] = "FETCH_SUCCESS";
    IconTokens["FETCH_SUCCESS_IMAGE"] = "FETCH_SUCCESS_IMAGE";
    IconTokens["REFRESH"] = "REFRESH";
    IconTokens["RIGHT_BLACK_ARROW"] = "RIGHT_NLACK_ARROW";
    IconTokens["FETCH_RUPEE_ICON"] = "FETCH_RUPEE_ICON";
    IconTokens["DEVICE_MOBILE"] = "DEVICE_MOBILE";
    IconTokens["MFD_IMAGE_1"] = "MFD_IMAGE_1";
    IconTokens["HAND_COINS"] = "HAND_COINS";
    IconTokens["SECURED_SHIELD"] = "SECURED_SHIELD";
    IconTokens["COLLATERAL_ICON"] = "COLLATERAL_ICON";
    IconTokens["PREPAY_LOAN_ICON"] = "PREPAY_LOAN_ICON";
    IconTokens["MUTUAL_FUNDS_ICON"] = "MUTUAL_FUNDS_ICON";
    IconTokens["DISCARD_LOAN_ICON"] = "DISCARD_LOAN_ICON";
    IconTokens["POOR_EXPERIENCE_ICON"] = "POOR_EXPERIENCE_ICON";
    IconTokens["OTHER_FEEDBACK_ICON"] = "OTHER_FEEDBACK_ICON";
    IconTokens["EYESLASH_ICON"] = "EYESLASH_ICON";
    IconTokens["FLASH_ICON"] = "FLASH_ICON";
    IconTokens["FOLDED_HANDS_ICON"] = "FOLDED_HANDS_ICON";
    IconTokens["MEDICAL_ICON"] = "MEDICAL_ICON";
    IconTokens["FLIGHT_ICON"] = "FLIGHT_ICON";
    IconTokens["CELEBRATION_ICON"] = "CELEBRATION_ICON";
    IconTokens["EMERGENCY_FUNDS_ICON"] = "EMERGENCY_FUNDS_ICON";
    IconTokens["CREDIT_CASH"] = "CREDIT_CASH";
    IconTokens["ZERO_CASH"] = "ZERO_CASH";
    IconTokens["CREDIT_HEALTH"] = "CREDIT_HEALTH";
    IconTokens["SMILY_FACE"] = "SMILY_FACE";
    IconTokens["INTEREST_RATE_ICON"] = "INTEREST_RATE_ICON";
    IconTokens["CREDIT_LINE_ICON"] = "CREDIT_LINE_ICON";
    IconTokens["MONEY_ICON"] = "MONEY_ICON";
    IconTokens["BIOMETRIC_PERMISSION"] = "BIOMETRIC_PERMISSION";
    IconTokens["COLLATERAL_SECURITIES"] = "COLLATERAL_SECURITIES";
    IconTokens["CASH_WITHDRAWAL"] = "CASH_WITHDRAWAL";
    IconTokens["HELP_AND_SUPPORT"] = "HELP_AND_SUPPORT";
    IconTokens["INTEREST_RATE_ICON_FAQ"] = "INTEREST_RATE_ICON_FAQ";
    IconTokens["YES_ICON"] = "YES_ICON";
    IconTokens["NO_ICON"] = "NO_ICON";
    IconTokens["SMILE_FACE_ICON"] = "SMILE_FACE_ICON";
    IconTokens["REPAY_ICON"] = "REPAY_ICON";
    IconTokens["RENEWAL_ICON"] = "RENEWAL_ICON";
})(IconTokens || (IconTokens = {}));
export var IconSizeTokens;
(function (IconSizeTokens) {
    IconSizeTokens["XXS"] = "XXS";
    IconSizeTokens["XS"] = "XS";
    IconSizeTokens["SM"] = "SM";
    IconSizeTokens["MD"] = "MD";
    IconSizeTokens["LG"] = "LG";
    IconSizeTokens["XL"] = "XL";
    IconSizeTokens["XXL"] = "XXL";
    IconSizeTokens["XXXL"] = "XXXL";
    IconSizeTokens["XXXXL"] = "XXXXl";
    IconSizeTokens["XXXXXL"] = "XXXXXl";
    IconSizeTokens["XXXXXXL"] = "XXXXXXl";
    IconSizeTokens["XXXXXXXL"] = "XXXXXXXl";
    IconSizeTokens["XXXXXXXXL"] = "XXXXXXXXl";
    IconSizeTokens["Size56"] = "Size56";
    IconSizeTokens["Size96"] = "Size96";
    IconSizeTokens["Size52"] = "Size52";
    IconSizeTokens["Size36"] = "Size36";
    IconSizeTokens["SIZE_164"] = "SIZE_164";
    IconSizeTokens["LARGE_DLS"] = "LARGE_DLS";
    IconSizeTokens["MEDIUM_DLS"] = "MEDIUM_DLS";
    IconSizeTokens["SMALL_DLS"] = "SMALL_DLS";
    IconSizeTokens["SIZE_WEB_FULL"] = "SIZE_WEB_FULL";
})(IconSizeTokens || (IconSizeTokens = {}));
